import React, { useState } from 'react';

import styled, { css } from 'styled-components';
//import MemberTable from '../common/MemberTable';
import { Ring } from 'react-awesome-spinners';
import CommenButton from '../common/Button';
import { selectMainMembershipState, selectMainMembership, timeValueToDate, sort, sortReverse, inputNumberAutoComma, dateToString } from '../../lib/commonFunc/commonFunc'
import Select from 'react-select';
import palette from '../../lib/styles/palette';
import Pagination from '@material-ui/lab/Pagination';
import { GoSearch } from 'react-icons/go';
import { MdRefresh, MdSmartphone } from 'react-icons/md';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextField from '@material-ui/core/TextField';

const Wrapper = styled.div`
  margin-top: 24px;
  padding-bottom: 40px;
`;

const Table = styled.table`
  font-family: 'Noto Sans KR', sans-serif;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;

  th, td {
    border: 1px solid #e0e4ea;
    padding: 8px 12px;
    text-align: center;
  }

  thead th {
    background: #f5f7fa;
    font-weight: 700;
    color: #2c3e50;
    white-space: nowrap;
  }

  tbody td {
    color: #555;
  }

  tbody tr:hover {
    background: #f9fbfd;
  }
`;

const TextSpace = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 1.25rem;
  color: #868e96;
`;

const DateBlock = styled.td`
  padding: 10px;
  font-weight: 600;
`;

const SectionWrapper = styled.div`
  margin-bottom: 32px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: visible;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
  border-radius: 12px 12px 0 0;
`;

const SectionTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
`;

const SectionBody = styled.div`
  padding: 24px;
`;

const PointCard = styled.div`
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;

  .point-title {
    font-weight: 700;
    color: #2c3e50;
    font-size: 1rem;
    padding-bottom: 12px;
  }

  .point-main {
    font-size: 1.4rem;
    font-weight: 700;
    color: ${palette.webCyan[5]};
    padding-bottom: 14px;
  }

  .point-row {
    color: #555;
    font-size: 0.92rem;
    padding-bottom: 4px;
  }
`;

const FilterBox = styled.div`
  padding: 20px 24px;
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  margin-bottom: 24px;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  & + & {
    margin-top: 16px;
  }
`;

const FieldLabel = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
  min-width: 50px;
`;

const RegistLabel = styled.div`
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e50;
  width: 120px;
  flex-shrink: 0;
`;

const TextInput = styled.input`
  width: 400px;
  border: 1px solid ${palette.inputBorder};
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.95rem;
  transition: border-color 0.15s ease;

  &:focus {
    outline: none;
    border-color: ${palette.inputBorderFocus};
  }
`;

const PrimaryButton = styled.button`
  background: ${palette.webCyan[5]};
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Line = styled.div`
    width: 100%;
`;
const TabBlock = styled.div`
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 1px solid #e0e4ea;
`;
const TabText = styled.div`
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  padding: 12px 4px;
  color: #868e96;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s ease, border-color 0.15s ease;
  & + & {
    margin-left: 40px;
  }
  ${(props) =>
        props.active &&
        css`
      font-weight: 700;
      color: ${palette.webCyan[5]};
      border-bottom-color: ${palette.webCyan[5]};
    `}
`;


const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      width: state.selectProps.width,
      borderBottom: '1px dotted pink',
      color: state.selectProps.menuColor,
      padding: 20,
      fontSize: '0.95rem',
      'z-index': 500,
    }),
    indicatorSeparator: (provided, state) => ({
      backgroundColor: 'none',
    }),
    indicatorContainer: (provided, state) => ({
      color: '#646464',
    }),
    input: () => ({
      curosr: 'pointer',
    }),
    control: (_, { selectProps: { width } }) => ({
      width: width,
      display: 'flex',
      color: '#fff',
      'z-index': 500,
      curosr: 'pointer',
      border: '1px solid #ccc',
      fontSize: '0.95rem',
      paddingLeft: '10px',
      borderRadius: '5px'
    }),
    placeholder: () => ({
      cursor: 'pointer',
      color: '#646464',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    },
  };


const registSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '42px',
    width: '250px',
    borderColor: state.isFocused ? palette.webCyan[5] : (palette.inputBorder || '#CDD9ED'),
    borderRadius: '6px',
    boxShadow: 'none',
    fontSize: '0.95rem',
    '&:hover': { borderColor: palette.webCyan[5] },
  }),
  valueContainer: (provided) => ({ ...provided, padding: '0 12px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (provided) => ({ ...provided, zIndex: 500, fontSize: '0.92rem' }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#eef4ff' : '#fff',
    color: '#1f2933',
  }),
};

const downloadExcel = (date, tableName) => {
    const table = document.getElementsByClassName(tableName)[0];
  
    let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text +=
      '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
    tab_text += '<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
    tab_text += '<x:Name>Test Sheet</x:Name>';
    tab_text +=
      '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text += '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text += "<table border='1px'>";
  
    let exportTable = table.cloneNode(true);
  
    tab_text += exportTable.outerHTML;
    tab_text += '</table></body></html>';
    let data_type = 'data:application/vnd.ms-excel';
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    let fileName = date + '_Table' + '.xls';
  
    // browser 처리
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      //ie 용
      if (window.navigator.msSaveBlob) {
        let blob = new Blob([tab_text], {
          type: 'application/csv;charset=utf-8;',
        });
        navigator.msSaveBlob(blob, fileName);
      }
    } else {
      //그외
      let blob2 = new Blob([tab_text], {
        type: 'application/csv;charset=utf-8;',
      });
      let filename = fileName;
      let elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob2);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
};

const AdminClubSms = ({
    smsPaymentList,
    aligoPoint,
    selectClub,
    setSelectClub,
    clubOptions,
    smsNumber,
    setSmsNumber,
    onChangeSmsNumber,
}) => {
    const [clubfilter, setclubfilter] = useState(0)
    const [datefilter, setdatefilter] = useState({startTime:0, endTime:0})
    const [pageType, setPageType] = useState('paymentResult')

    let clubList = [{label:'전체', value:0}];

    for (let i = 0; i < smsPaymentList.length; i++) {
        let skip = false;
        for (let j = 0; j < clubList.length; j++) {
            if(clubList[j].value == smsPaymentList[i].clubID)
            {
                skip = true;
                break;
            }
        }

        if(!skip)
        {
            clubList.push({label:smsPaymentList[i].clubName, value:smsPaymentList[i].clubID});
        }
    }

    let dateList = [
        {label:'전체', value:{startTime:0, endTime:0}}
    ]
    let today = new Date(Date.now())
    today.setHours(0,0,0,0)
    today.setDate(1)
    let startTime = Number(today.getTime()/1000)
    today.setMonth(today.getMonth()+1)
    today.setDate(today.getDate()-1)
    let endTime = Number(today.getTime()/1000)
    dateList.push({label:`${today.getMonth()+1}월`, value:{endTime, startTime}})

    today.setDate(1)
    for (let i = 0; i < 11; i++) {
        endTime = Number(today.getTime()/1000)
        today.setMonth(today.getMonth() - 1)
        startTime = Number(today.getTime()/1000)
        dateList.push({label:`${today.getMonth()+1}월`, value:{endTime, startTime}})
    }

    const onClickPeriod = (period)=>{
        let tempdate = new Date()

        let startTime = 0;
        let endTime = parseInt(tempdate.getTime()/1000);
        if(period == 'month')
        {
            tempdate.setDate(1)
            tempdate.setHours(0, 0, 0, 0)
            startTime = parseInt(tempdate.getTime()/1000);
        }
        else if(period == '3months')
        {
            tempdate.setDate(1)
            tempdate.setHours(0, 0, 0, 0)
            tempdate.setMonth(tempdate.getMonth() - 2)
            startTime = parseInt(tempdate.getTime()/1000);
        }
        else if(period == '6months')
        {
            tempdate.setDate(1)
            tempdate.setHours(0, 0, 0, 0)
            tempdate.setMonth(tempdate.getMonth() - 5)
            startTime = parseInt(tempdate.getTime()/1000);
        }
        
        setdatefilter({startTime, endTime})
    }

    if(datefilter.startTime == 0 && datefilter.endTime == 0)
    {
        onClickPeriod('6months')
    }

    const changeDateFormat = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const year1 = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const dateStr = `${year1}-${month}-${day}`;

        return dateStr
    }
    
  return (
    <Wrapper>
        <TabBlock >
            <div style={{ display: 'flex' }}>
                <TabText
                    onClick={() => setPageType('paymentResult')}
                    active={pageType === 'paymentResult'}
                >
                    충전 내역
                </TabText>
                <TabText
                    onClick={() => setPageType('numberRegist')}
                    active={pageType === 'numberRegist'}
                >
                    발신번호 등록 & 변경
                </TabText>
            </div>
        </TabBlock>
        {
            pageType === 'paymentResult'?
            <div>
                <PointCard>
                    <div className="point-title">현재 알리고 문자 남은 포인트</div>
                    <div className="point-main">{inputNumberAutoComma(Math.floor(aligoPoint.smsCount * 8.4))}P</div>
                    <div className="point-row">단문 : {inputNumberAutoComma(aligoPoint.smsCount)}건</div>
                    <div className="point-row">장문 : {inputNumberAutoComma(aligoPoint.lmsCount)}건</div>
                    <div className="point-row">그림 : {inputNumberAutoComma(aligoPoint.mmsCount)}건</div>
                </PointCard>
                <FilterBox>
                <FilterRow>
                    <TextField
                        id="startTime"
                        label="시작일"
                        name="startTime"
                        type="date"
                        value={changeDateFormat(datefilter.startTime)}
                        onChange={(e) =>{
                            let date = new Date(e.target.value)

                            date.setHours(0, 0, 0, 0)

                            setdatefilter({startTime:parseInt(date.getTime()/1000), endTime:datefilter.endTime})
                        }}
                        InputLabelProps={{
                            shrink: true,
                    }}
                    />
                    <TextSpace>~</TextSpace>
                    <TextField
                        id="endTime"
                        label="종료일"
                        name="endTime"
                        type="date"
                        value={changeDateFormat(datefilter.endTime)}
                        onChange={(e) =>{
                            let date = new Date(e.target.value)

                            date.setHours(23, 59, 59)

                            setdatefilter({startTime:datefilter.startTime, endTime:parseInt(date.getTime()/1000)})
                        }}
                        InputLabelProps={{
                            shrink: true,
                    }}
                    />
                    <div style={{width:'20px'}}/>
                    <ButtonGroup
                        color="primary"
                        aria-label="outlined primary button group"
                    >
                        <Button onClick={() => onClickPeriod('month')}>1달</Button>
                        <Button onClick={() => onClickPeriod('3months')}>3달</Button>
                        <Button onClick={() => onClickPeriod('6months')}>6달</Button>
                        <Button onClick={() => onClickPeriod('')}>전체</Button>
                    </ButtonGroup>
                </FilterRow>
                <FilterRow>
                        <FieldLabel>클럽 : </FieldLabel>
                        <Select
                            options={clubList}
                            onChange={(e)=>{
                                setclubfilter(e.value)
                            }}
                            defaultValue={0}
                            isSearchable={false}
                            //style={{width:'250px'}}
                            styles={{ 
                                container: provided => ({...provided, width: '400px', padding: 0, border: 0})
                            }}
                            height="450px"
                            aria-labelledby="select"
                            placeholder="클럽 선택"
                            maxMenuHeight={'450px'}
                        />
                        {/* <div style={{width: '50px', marginLeft:'50px'}}>기간 : </div>
                        <Select
                            options={dateList}
                            onChange={(e)=>{
                                setdatefilter(e.value)
                            }}
                            defaultValue={{startTime:0, endTime:0}}
                            isSearchable={false}
                            //style={{width:'250px'}}
                            styles={{ 
                                container: provided => ({...provided, width: '400px', padding: 0, border: 0})
                            }}
                            height="450px"
                            aria-labelledby="select"
                            placeholder="기간 선택"
                            maxMenuHeight={'450px'}
                        /> */}
                </FilterRow>
                </FilterBox>
                <SectionWrapper>
                <SectionHeader>
                        <SectionTitle>문자 결제 내역</SectionTitle>
                        <CommenButton
                            onClick={() => downloadExcel('문자 결제 내역', 'smsPaymentResult')}
                        >{`Excel 다운로드`}</CommenButton>
                </SectionHeader>
                <SectionBody>
                <Table className="smsPaymentResult">
                    <thead>
                        <tr>
                        <td>클럽 이름</td>
                        <td>구매일</td>
                        <td>결제 금액</td>
                        <td>충전 포인트</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            smsPaymentList.map((dateData, idx1)=>{
                                if(clubfilter != 0 && dateData.clubID != clubfilter) return null;

                                if(datefilter.startTime != 0 && 
                                    (dateData.registTime < datefilter.startTime || dateData.registTime > datefilter.endTime) ) return null;
                                return (
                                <tr
                                    key={idx1}
                                >
                                    <td>{dateData.clubName}</td>
                                    <td>{dateToString(dateData.registTime)}</td>
                                    <td>{inputNumberAutoComma(dateData.price)}원</td>
                                    <td>{inputNumberAutoComma(dateData.base+dateData.bonus)}P</td>
                                </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
                </SectionBody>
                </SectionWrapper>
            </div>
            :
            pageType == 'numberRegist'?
            <SectionWrapper>
                <SectionBody>
                <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '18px'}}>
                    <RegistLabel>클럽 선택</RegistLabel>
                    <Select
                        options={clubOptions}
                        onChange={setSelectClub}
                        placeholder="클럽 선택"
                        styles={registSelectStyles}
                        isSearchable={false}
                        aria-labelledby="select"
                        value={selectClub}
                        width="250px"
                    />
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '18px'}}>
                    <RegistLabel>{'발신번호'}</RegistLabel>
                    <TextInput value={smsNumber} onChange={(e) => setSmsNumber(e.target.value)} type="text" style={{width: '400px'}}/>
                </div>
                <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '24px'}}>
                    <PrimaryButton onClick={() => onChangeSmsNumber()}>
                        발신번호 등록 & 변경
                    </PrimaryButton>
                </div>
                </SectionBody>
            </SectionWrapper>
            :null
        }
        <Line/>
    </Wrapper>
  );
};

export default React.memo(AdminClubSms);
